import { StyledInput } from '@/shared/styles';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLangStore } from '@/stores/LangStore/LangStore';
import { FeatureLimitGroupProps } from './FeatureLimit.consts';
import { StyledRequiredFieldGroup } from '../../Framework/Framework.styles';
import { StyledLabel } from '../../Forms/Forms.styles';
import { StyledFeatureGroupTitle } from './FeatureLimit.styles';

export const FeatureLimitGroup: React.FC<FeatureLimitGroupProps> = ({
  code,
  name,
  parameterName,
}: FeatureLimitGroupProps) => {
  const { t } = useTranslation();
  const isRtl = useLangStore((state) => state.isRtl);

  return (
    <StyledRequiredFieldGroup key={code}>
      <StyledFeatureGroupTitle $isRtl={isRtl()}>{name}</StyledFeatureGroupTitle>
      <StyledLabel>
        {t('admin.form.usage_price_monthly_limit')} ({t('optional')})
      </StyledLabel>
      <Form.Item name={[parameterName, code, 'monthlyLimitPrice']}>
        <StyledInput placeholder={t('admin.form.usage_price_monthly_limit')} />
      </Form.Item>
    </StyledRequiredFieldGroup>
  );
};
